const Text = ({className, textType, ...props }) => {
  return (
    <p className={className || ""} {...props}>{props.children}</p>
  );
};

export default Text;
